import { useMemo } from 'react';
import { Typography } from 'seagull';
import LegalTermsDropdownOld from "../../../../components/LegalTermsDropdownOld/LegalTermsDropdownOld";
import { useStore, useStoreActions } from "../../../../contexts";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { legalTermsModel } from "../../../../models";
import { selectors } from "../../../../store/state-selectors";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { getLegalTermsOld } from "../EditDraftsTable.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const getLegalTermsIdOld = draft => {
  const legalTerms = draft.legalTermsOld();
  return legalTerms != null && 'libraryLegalTermsId' in legalTerms ? legalTerms.libraryLegalTermsId : null;
};
const getLegalTermsId = draft => {
  var _draft$legalTermsDocu;
  return (_draft$legalTermsDocu = draft.legalTermsDocuments()[0]) === null || _draft$legalTermsDocu === void 0 ? void 0 : _draft$legalTermsDocu.legalTermsId;
};
function TermsOfServiceModalContent(_ref) {
  let {
    draft,
    setDraft
  } = _ref;
  const {
    MULTIPLE_LEGAL_TERMS_DOCUMENTS
  } = useFeatureFlags();
  const {
    fetchLegalTerms
  } = useStoreActions();
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const worksAt = useStore(selectors.user.business);
  const businessAndDraftLegalDocs = useMemo(() => {
    if (MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
      return [...(legalTermsDocuments !== null && legalTermsDocuments !== void 0 ? legalTermsDocuments : []), ...legalTermsModel.fromDraftLegalTerms(draft.legalTermsDocuments())];
    }
    const legalTerms = draft.legalTermsOld();
    if (legalTermsDocuments == null) return [];
    if (legalTermsDocuments.some(_ref2 => {
      let {
        id
      } = _ref2;
      return id === getLegalTermsIdOld(draft);
    })) return legalTermsDocuments;
    if ((legalTerms === null || legalTerms === void 0 ? void 0 : legalTerms.type) === 'libraryLegalTermsId') {
      return legalTermsDocuments.concat([legalTermsModel.fromDraftLegalTermsOld(legalTerms)]);
    }
    if (legalTermsDocuments.some(_ref3 => {
      let {
        id
      } = _ref3;
      return id === getLegalTermsIdOld(draft);
    })) {
      return legalTermsDocuments;
    }
    return legalTermsDocuments.concat([legalTermsModel.fromDraftLegalTermsOld(legalTerms)]);
  }, [legalTermsDocuments, draft]);
  const fileId = useMemo(() => {
    const {
      legalTermsDocumentId
    } = (worksAt === null || worksAt === void 0 ? void 0 : worksAt.settings) || {};
    if (MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
      var _getLegalTermsId;
      return (_getLegalTermsId = getLegalTermsId(draft)) !== null && _getLegalTermsId !== void 0 ? _getLegalTermsId : legalTermsDocumentId;
    } else {
      const legalTermsId = getLegalTermsIdOld(draft);
      return legalTermsId || legalTermsDocumentId || null;
    }
  }, [worksAt, draft]);
  return /*#__PURE__*/_jsx(LegalTermsDropdownOld, {
    legalTerms: businessAndDraftLegalDocs,
    selectedLegalTerms: businessAndDraftLegalDocs.find(_ref4 => {
      let {
        id
      } = _ref4;
      return id === fileId;
    }),
    onUpload: fetchLegalTerms,
    onChange: document => {
      setDraft(draft.setLegalTermsDocuments([legalTermsModel.toDraftLegalTermsDocuments(document)]));
    },
    onChangeOld: id => {
      setDraft(draft.setLegalTermsOld({
        type: 'libraryLegalTermsId',
        libraryLegalTermsId: id
      }));
    }
  });
}
export default function TermsOfServiceCell(_ref5) {
  var _legalTerms$name;
  let {
    isDisabled,
    disabledTooltip,
    draft,
    index,
    onOpenModal
  } = _ref5;
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const {
    MULTIPLE_LEGAL_TERMS_DOCUMENTS
  } = useFeatureFlags();
  const legalTerms = useMemo(() => MULTIPLE_LEGAL_TERMS_DOCUMENTS ? legalTermsModel.fromDraftLegalTerms(draft.legalTermsDocuments())[0] : getLegalTermsOld(draft, legalTermsDocuments), [draft, legalTermsDocuments, MULTIPLE_LEGAL_TERMS_DOCUMENTS]);
  const onClick = () => onOpenModal({
    renderContent: _ref6 => {
      let {
        draft,
        setDraft
      } = _ref6;
      return {
        title: 'Terms of service',
        testid: 'edit-terms-modal',
        content: /*#__PURE__*/_jsx(TermsOfServiceModalContent, {
          draft: draft,
          setDraft: setDraft
        }),
        onSubmit: defaultBehavior => {
          defaultBehavior();
        }
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-terms-of-service-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "terms-of-service-".concat(index),
      children: (_legalTerms$name = legalTerms === null || legalTerms === void 0 ? void 0 : legalTerms.name) !== null && _legalTerms$name !== void 0 ? _legalTerms$name : ''
    })
  });
}